import { render } from "./Pager.vue?vue&type=template&id=d21cbb22&ts=true"
import script from "./Pager.vue?vue&type=script&lang=ts"
export * from "./Pager.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Vyvoj\\temporary\\htdocs\\dev.poski.loc\\clevero.cz\\trunk\\www\\frontend\\CID\\poski\\klasik-2020\\js\\libraries\\store-catalog\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__